import { render, staticRenderFns } from "./BoxReport.vue?vue&type=template&id=08ec36a6"
import script from "./BoxReport.vue?vue&type=script&lang=js"
export * from "./BoxReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports